// Generated by psc version 0.10.2
"use strict";
var Prelude = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Prelude.purs");
var Control_Alt = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Alt.purs");
var Control_Comonad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Comonad.purs");
var Control_Extend = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Extend.purs");
var Data_Foldable = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-foldable-traversable/src/Data/Foldable.purs");
var Data_Functor_Invariant = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-invariant/src/Data/Functor/Invariant.purs");
var Data_Monoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-monoid/src/Data/Monoid.purs");
var Data_Newtype = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-newtype/src/Data/Newtype.purs");
var Data_Traversable = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-foldable-traversable/src/Data/Traversable.purs");
var Data_Eq = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Eq.purs");
var Data_Ord = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ord.purs");
var Data_Bounded = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Bounded.purs");
var Data_HeytingAlgebra = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/HeytingAlgebra.purs");
var Data_BooleanAlgebra = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/BooleanAlgebra.purs");
var Data_Semigroup = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semigroup.purs");
var Data_Semiring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semiring.purs");
var Data_EuclideanRing = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/EuclideanRing.purs");
var Data_Ring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ring.purs");
var Data_CommutativeRing = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/CommutativeRing.purs");
var Data_Field = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Field.purs");
var Data_Show = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Show.purs");
var Data_Functor = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.purs");
var Control_Apply = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Apply.purs");
var Control_Applicative = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Applicative.purs");
var Control_Bind = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Bind.purs");
var Control_Monad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Monad.purs");
var Identity = function (x) {
    return x;
};
var showIdentity = function (dictShow) {
    return new Data_Show.Show(function (v) {
        return "(Identity " + (Data_Show.show(dictShow)(v) + ")");
    });
};
var semiringIdentity = function (dictSemiring) {
    return dictSemiring;
};
var semigroupIdenity = function (dictSemigroup) {
    return dictSemigroup;
};
var ringIdentity = function (dictRing) {
    return dictRing;
};
var ordIdentity = function (dictOrd) {
    return dictOrd;
};
var newtypeIdentity = new Data_Newtype.Newtype(function (n) {
    return n;
}, Identity);
var monoidIdentity = function (dictMonoid) {
    return dictMonoid;
};
var heytingAlgebraIdentity = function (dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var functorIdentity = new Data_Functor.Functor(function (f) {
    return function (v) {
        return f(v);
    };
});
var invariantIdentity = new Data_Functor_Invariant.Invariant(Data_Functor_Invariant.imapF(functorIdentity));
var foldableIdentity = new Data_Foldable.Foldable(function (dictMonoid) {
    return function (f) {
        return function (v) {
            return f(v);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return f(z)(v);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return f(v)(z);
        };
    };
});
var traversableIdentity = new Data_Traversable.Traversable(function () {
    return foldableIdentity;
}, function () {
    return functorIdentity;
}, function (dictApplicative) {
    return function (v) {
        return Data_Functor.map((dictApplicative["__superclass_Control.Apply.Apply_0"]())["__superclass_Data.Functor.Functor_0"]())(Identity)(v);
    };
}, function (dictApplicative) {
    return function (f) {
        return function (v) {
            return Data_Functor.map((dictApplicative["__superclass_Control.Apply.Apply_0"]())["__superclass_Data.Functor.Functor_0"]())(Identity)(f(v));
        };
    };
});
var fieldIdentity = function (dictField) {
    return dictField;
};
var extendIdentity = new Control_Extend.Extend(function () {
    return functorIdentity;
}, function (f) {
    return function (m) {
        return f(m);
    };
});
var euclideanRingIdentity = function (dictEuclideanRing) {
    return dictEuclideanRing;
};
var eqIdentity = function (dictEq) {
    return dictEq;
};
var comonadIdentity = new Control_Comonad.Comonad(function () {
    return extendIdentity;
}, function (v) {
    return v;
});
var commutativeRingIdentity = function (dictCommutativeRing) {
    return dictCommutativeRing;
};
var boundedIdentity = function (dictBounded) {
    return dictBounded;
};
var booleanAlgebraIdentity = function (dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var applyIdentity = new Control_Apply.Apply(function () {
    return functorIdentity;
}, function (v) {
    return function (v1) {
        return v(v1);
    };
});
var bindIdentity = new Control_Bind.Bind(function () {
    return applyIdentity;
}, function (v) {
    return function (f) {
        return f(v);
    };
});
var applicativeIdentity = new Control_Applicative.Applicative(function () {
    return applyIdentity;
}, Identity);
var monadIdentity = new Control_Monad.Monad(function () {
    return applicativeIdentity;
}, function () {
    return bindIdentity;
});
var altIdentity = new Control_Alt.Alt(function () {
    return functorIdentity;
}, function (x) {
    return function (v) {
        return x;
    };
});
module.exports = {
    Identity: Identity, 
    newtypeIdentity: newtypeIdentity, 
    eqIdentity: eqIdentity, 
    ordIdentity: ordIdentity, 
    boundedIdentity: boundedIdentity, 
    heytingAlgebraIdentity: heytingAlgebraIdentity, 
    booleanAlgebraIdentity: booleanAlgebraIdentity, 
    semigroupIdenity: semigroupIdenity, 
    monoidIdentity: monoidIdentity, 
    semiringIdentity: semiringIdentity, 
    euclideanRingIdentity: euclideanRingIdentity, 
    ringIdentity: ringIdentity, 
    commutativeRingIdentity: commutativeRingIdentity, 
    fieldIdentity: fieldIdentity, 
    showIdentity: showIdentity, 
    functorIdentity: functorIdentity, 
    invariantIdentity: invariantIdentity, 
    altIdentity: altIdentity, 
    applyIdentity: applyIdentity, 
    applicativeIdentity: applicativeIdentity, 
    bindIdentity: bindIdentity, 
    monadIdentity: monadIdentity, 
    extendIdentity: extendIdentity, 
    comonadIdentity: comonadIdentity, 
    foldableIdentity: foldableIdentity, 
    traversableIdentity: traversableIdentity
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-identity/src/Data/Identity.purs
// module id = 55
// module chunks = 0